import firebase from "firebase";

// Initialize Firebase
const config = {
  databaseURL: "https://thea-academy-mx.firebaseio.com",
  apiKey: "AIzaSyCokYSp53bDWXMSMWuivDpRHkzS4JHD1yc",
  authDomain: "thea-academy-mx.firebaseapp.com",
  projectId: "thea-academy-mx",
  storageBucket: "thea-academy-mx.appspot.com",
  messagingSenderId: "445114866801",
  appId: "1:445114866801:web:e93962f45278b410374fd0",
  measurementId: "G-56W6PW12KK"
};
firebase.initializeApp(config);
firebase.auth().languageCode = 'es'
const auth = firebase.auth();
const functions = firebase.functions();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
const githubAuthProvider = new firebase.auth.GithubAuthProvider();
const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();

const database = firebase.firestore();

export {
  database,
  auth,
  functions,
  googleAuthProvider,
  githubAuthProvider,
  facebookAuthProvider,
  twitterAuthProvider
};
